<template>
  <div>
    <!-- start action dropdown-->
    <v-layout
      v-if="editPermission"
      row
    >
      <v-select
        v-model="dropdown.action"
        :disabled="!selectedGatePasses.length"
        :items="dropdownItems"
        item-value="value"
        item-test="text"
        label="Choose Action"
        solo
      />
      <!-- only show if cancel is slected-->
      <v-select
        v-if="dropdown.action == 'cancel'"
        v-model="dropdown.confirmCancel"
        :disabled="!selectedGatePasses.length"
        :items="confirmationMenu"
        item-value="value"
        item-test="text"
        label="Are You sure?"
        solo
      />
      <!-- only show if any action is selected -->
      <v-btn
        v-if="String(dropdown.action) != 'false' && dropdown.confirmCancel"
        @click="performAction()"
      >
        Apply
      </v-btn>
    </v-layout>
    <!-- end action dropdown -->
    <!-- start gatepasses -->
    <div v-max-height="{height: '50vh'}">
      <v-alert
        :value="!gatePasses.length && !loading"
        type="info"
      >
        No Results
      </v-alert>
      <v-progress-linear
        v-if="loading"
        :indeterminate="true"
      />
      <v-card-item
        v-for="gatePass in gatePasses"
        :key="gatePass.gatePassID"
      >
        <template slot="title">
          <v-flex xs5>
            {{ gatePass.year ? gatePass.year + ' Season Gate Pass' : 'Standard Gate Pass' }}
          </v-flex>
          <v-flex v-if="editPermission && !(gatePass.itineraryID || gatePass.parkingBookingID || gatePass.date || gatePass.year)">
            <IconButton
              v-if="Number(gatePass.used)"
              tooltip="Unlock"
              color="orange"
              icon="fa-lock"
              @click="updateGatePassRenew({gatePassID: gatePass.gatePassID})"
            />
            <IconButton
              v-else
              tooltip="Lock"
              color="orange"
              icon="fa-lock-open"
              @click="updateGatePassRevoke({gatePassID: gatePass.gatePassID})"
            />
          </v-flex>
        </template>
        <template
          v-if="editPermission"
          slot="actions"
        >
          <v-checkbox
            :value="gatePass.gatePassID"
            v-model="selectedGatePasses"
            type="checkbox"
            class="text-xs-right"
          />
        </template>
        <template>
          <v-layout row>
            <v-flex xs8>
              <strong>ID:</strong> {{ gatePass.gatePassID }}<br>
              <strong>Assigned to:</strong>
              <span v-if="gatePass.itineraryID"> Itinerary {{ gatePass.itineraryID }}</span>
              <span v-else-if="gatePass.parkingBookingID"> Parking {{ gatePass.parkingBookingID }}</span>
              <span v-else-if="gatePass.date"> {{ gatePass.date }}</span>
              <span v-else-if="Number(gatePass.used)"> revoked</span>
              <span v-else> Unassigned </span>
            </v-flex>
            <v-flex>
              <strong>Price:</strong> ${{ gatePass.price }}
            </v-flex>
          </v-layout>
        </template>
      </v-card-item>
    </div>
    <!-- end gatepasses -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      loading: true,
      dropdownItems: [
        {
          value: 'cancel',
          text: 'Cancel'
        }
      ],
      confirmationMenu: [
        {
          value: false,
          text: 'No'
        },
        {
          value: true,
          text: 'Yes'
        }
      ],
      dropdown: {
        action: false,
        confirmCancel: null
      },
      selectedGatePasses: []
    }
  },
  computed: {
    ...mapGetters({
      gatePasses: 'passes/gatePasses'
    }),
    editPermission () {
      return this.assertSetting('editReservations', 1)
    }
  },
  created () {
    this.getGatePasses().then(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions({
      getGatePasses: 'passes/getGatePasses',
      deleteGatePasses: 'passes/deleteGatePasses',
      getBaxterBucks: 'person/getBaxterBucks',
      updateGatePassRevoke: 'passes/updateGatePassRevoke',
      updateGatePassRenew: 'passes/updateGatePassRenew'
    }),
    refresh () {
      this.loading = true
      // reload the passes
      this.getGatePasses().then(() => {
        this.loading = false
      })
      this.selectedGatePasses = []
      // reload baxter bucks in case anything changed
      this.getBaxterBucks()
    },
    performAction () {
      switch (this.dropdown.action) {
        case 'cancel':
          this.cancelReservations()
          break
        default:
          console.log('no action selected')
      }
    },
    cancelReservations () { // cancel the selected reservations
      if (!this.dropdown.confirmCancel) { // confirmation dropdown must be yes
        return
      }
      // delete gatePasses
      this.deleteGatePasses({ gatePassIDs: this.selectedGatePasses }).then(this.refresh)
    }
  }
}
</script>
